import { api } from './api';

export const receivingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getReceivings: builder.query({
      query: ({
        filter,
        filterKey,
        headerFilters,
        order,
        orderBy,
        pageIndex,
        pageSize,
        dateRange,
      }) => {
        return {
          url: 'getReceivings',
          method: 'POST',
          body: {
            filter,
            filterKey,
            headerFilters,
            order,
            orderBy,
            pageIndex,
            pageSize,
            dateRange,
          },
        };
      },
    }),

    getReceiving: builder.mutation({
      query: ({
        filter,
        filterKey,
        headerFilters,
        order,
        orderBy,
        receivingId,
        receivingIndex,
        dateRange,
      }) => {
        return {
          url: 'getReceiving',
          method: 'POST',
          body: {
            filter,
            filterKey,
            headerFilters,
            order,
            orderBy,
            receivingId,
            receivingIndex,
            dateRange,
          },
        };
      },
    }),

    saveReceiving: builder.mutation({
      query: ({ receivingId, diffs }) => {
        return {
          url: 'saveReceiving',
          method: 'POST',
          body: {
            receivingId,
            diffs,
          },
        };
      },
    }),

  }),
});

export const {
  useGetReceivingsQuery,
  useGetReceivingMutation,
  useSaveReceivingMutation,
} = receivingApi;
